




































import {Component, Emit, Prop, Vue, Watch} from 'vue-property-decorator';
import BButton from 'buefy/src/components/button/Button.vue';
import {namespace} from 'vuex-class';
import {ReviewRate} from '@/store/RateReviewFaq/types';
import BIcon from 'buefy/src/components/icon/Icon.vue';
import BInput from 'buefy/src/components/input/Input.vue';
import BLoading from 'buefy/src/components/loading/Loading.vue';
import BField from 'buefy/src/components/field/Field.vue';
import {MAFUser} from '@/store/User/types';
import {DateTime} from 'luxon';

/* tslint:disable:no-console */
/* tslint:disable:no-empty */

const userNamespace = namespace('userState');
const friendNamespace = namespace('friendState');

@Component({
    components: {BButton,
    },
})

export default class PaymentBody extends Vue {
  @Prop() public readonly selectedCoinPayment: any;
  @userNamespace.State('self') public readonly myself!: MAFUser;
  @userNamespace.Action('purchase') public purchase: any;
  @friendNamespace.Action('purchaseCoins') public purchaseCoins!: any;

  public card: any = {
    number: '',
    cvc: '',
    exp: '',
  };
  public errors: any[] = [];
  public stripePublishableKey: string = 'pk_live_vO2Xd2PY3j85OtV68hp3atbz008zvKnORj';
  public stripeCheck: boolean = false;
  public isLoading: boolean = false;

  public validate() {
    this.errors = [];
    let valid = true;
    if (!this.card.number) {
      valid = false;
      this.errors.push('Card Number is required');
    }
    if (!this.card.cvc) {
      valid = false;
      this.errors.push('CVC is required');
    }
    if (!this.card.exp) {
      valid = false;
      this.errors.push('Expiration date is required');
    }
    if (valid) {
      this.createToken();
    }
  }

  public createToken() {
    // eslint-disable-next-line
    this.stripeCheck = true;
    (window as any).Stripe.setPublishableKey(this.stripePublishableKey);
    (window as any).Stripe.createToken(this.card, (status: any, response: any) => {
      if (response.error) {
        this.stripeCheck = false;
        this.errors.push(response.error.message);
        // eslint-disable-next-line
        console.error(response);
      } else {
        const payload = {
          coins: this.selectedCoinPayment,
          token: response.id,
          email: this.myself.email,
          description: `${this.myself.name} purchased ${this.selectedCoinPayment.coins}`,
        };

        this.purchaseCoins({body: payload, me: this.myself});
        this.close();
      }
    });
  }

  public async buy(what: string) {
    this.isLoading = true;
    const {res, err} = await this.purchase({what});
    this.isLoading = false;
    if (err) {
      this.$toast.open({message: err, type: 'is-danger', position: 'is-bottom', duration: 2000});
    }
  }

  @Emit('close')
  public close() {
  }
}
